import { useQuery } from '@tanstack/react-query';

export type UseGetTemplateOpts = {
  templateId?: string | null;
};

export const useGetTemplate = ({ templateId }: UseGetTemplateOpts) => {
  return useQuery({
    queryKey: ['templates', templateId],
    queryFn: async () => {
      if (!templateId) return null;

      const response = await fetch(`https://public.cradl.ai/templates/${templateId}`);
      if (!response.ok) return null;

      return await response.json();
    },
    enabled: !!templateId,
  });
};
